import React from "react";
import {
    CheckCircleOutlined,
    DownloadOutlined,
    LaptopOutlined,
    SafetyOutlined,
    WindowsOutlined,
    FolderOpenOutlined,
    LoginOutlined,
    BookOutlined,
} from "@ant-design/icons";

const DOWNLOAD_URL =
    "/downloads/os-books/OS-BOOKS-Setup.exe";

const FILE_SIZE =
    "13M";

const FILE_SHA256 =
    "b9f7afb3adc10974d00b53025620a843a616d21ebe1c27ec8922d2890c7c71ed";

export default function WindowsBooksGuide() {

    return (
        <div className="min-h-screen bg-[#f4f7fb] px-3 py-5 md:px-6 md:py-10">

            <div className="mx-auto max-w-[920px]">

                {/* HERO */}
                <div className="
                    overflow-hidden
                    rounded-[24px]
                    border border-blue-100
                    bg-white
                    shadow-sm
                ">

                    <div className="
                        bg-gradient-to-r
                        from-[#1559e8]
                        via-[#1677ff]
                        to-[#11acd0]
                        px-5 py-8
                        text-white
                        md:px-10 md:py-10
                    ">

                        <div className="
                            mb-4
                            flex h-14 w-14
                            items-center justify-center
                            rounded-2xl
                            bg-white/15
                            text-[30px]
                        ">
                            <WindowsOutlined />
                        </div>

                        <div className="
                            text-[13px]
                            font-bold
                            uppercase
                            tracking-[.12em]
                            text-blue-100
                        ">
                            OS BOOKS
                        </div>

                        <h1 className="
                            m-0 mt-1
                            text-[27px]
                            font-bold
                            leading-tight
                            md:text-[36px]
                        ">
                            Đọc sách trên máy tính Windows
                        </h1>

                        <p className="
                            mb-0 mt-3
                            max-w-[720px]
                            text-[15px]
                            leading-6
                            text-blue-50
                            md:text-[16px]
                        ">
                            Để đọc sách trên máy tính Windows, bạn cần cài đặt
                            ứng dụng OS BOOKS. Sau khi cài đặt, hãy đăng nhập
                            bằng tài khoản của bạn để xem toàn bộ sách đã sở hữu.
                        </p>

                    </div>


                    <div className="p-5 md:p-10">

                        {/* DOWNLOAD */}
                        <div className="
                            rounded-2xl
                            border border-blue-100
                            bg-[#f4f9ff]
                            p-5
                            md:p-6
                        ">

                            <div className="
                                flex flex-col
                                gap-4
                                md:flex-row
                                md:items-center
                                md:justify-between
                            ">

                                <div>

                                    <div className="
                                        flex items-center gap-2
                                        text-[18px]
                                        font-bold
                                        text-gray-900
                                    ">
                                        <LaptopOutlined
                                            className="text-blue-600"
                                        />

                                        OS BOOKS cho Windows
                                    </div>

                                    <div className="
                                        mt-1
                                        text-[13px]
                                        leading-5
                                        text-gray-500
                                    ">
                                        Bộ cài chính thức từ
                                        cuahangykhoa.com
                                        {" • "}
                                        Dung lượng: {FILE_SIZE}
                                    </div>

                                </div>


                                <a
                                    href={DOWNLOAD_URL}
                                    download="OS-BOOKS-Setup.exe"
                                    className="
                                        inline-flex
                                        min-h-[52px]
                                        items-center
                                        justify-center
                                        gap-2
                                        rounded-xl
                                        bg-blue-600
                                        px-6
                                        text-[15px]
                                        font-bold
                                        text-white
                                        no-underline
                                        shadow-sm
                                        transition
                                        hover:bg-blue-700
                                        hover:text-white
                                    "
                                >
                                    <DownloadOutlined />

                                    TẢI OS BOOKS CHO WINDOWS
                                </a>

                            </div>

                        </div>


                        {/* STEPS */}
                        <h2 className="
                            mb-5 mt-8
                            text-[22px]
                            font-bold
                            text-gray-900
                            md:text-[25px]
                        ">
                            Hướng dẫn cài đặt từng bước
                        </h2>


                        <div className="space-y-4">

                            <Step
                                number="1"
                                icon={<DownloadOutlined />}
                                title="Tải OS BOOKS"
                            >
                                Nhấn nút <b>Tải OS BOOKS cho Windows</b>
                                {" "}ở phía trên. File có tên
                                {" "}<b>OS-BOOKS-Setup.exe</b>.
                            </Step>


                            <Step
                                number="2"
                                icon={<FolderOpenOutlined />}
                                title="Mở file vừa tải"
                            >
                                Sau khi tải xong, mở thư mục
                                {" "}<b>Downloads / Tải xuống</b>
                                {" "}trên máy tính và nhấp đúp vào
                                {" "}<b>OS-BOOKS-Setup.exe</b>.
                            </Step>


                            <Step
                                number="3"
                                icon={<SafetyOutlined />}
                                title="Nếu Windows hiện màn hình cảnh báo màu xanh"
                            >
                                Nếu thấy thông báo
                                {" "}<b>Windows protected your PC</b>,
                                hãy chọn
                                {" "}<b>More info</b>
                                {" "}(Thông tin thêm).
                            </Step>


                            <Step
                                number="4"
                                icon={<CheckCircleOutlined />}
                                title='Chọn "Run anyway"'
                            >
                                Sau khi chọn
                                {" "}<b>More info</b>,
                                nút
                                {" "}<b>Run anyway</b>
                                {" "}(Vẫn chạy) sẽ xuất hiện.
                                Nhấn nút này để mở bộ cài OS BOOKS.
                            </Step>


                            <Step
                                number="5"
                                icon={<LaptopOutlined />}
                                title="Tiến hành cài đặt"
                            >
                                Làm theo các bước trên màn hình cho đến
                                khi quá trình cài đặt hoàn tất.
                                Sau đó mở ứng dụng
                                {" "}<b>OS BOOKS</b>.
                            </Step>


                            <Step
                                number="6"
                                icon={<LoginOutlined />}
                                title="Đăng nhập tài khoản của bạn"
                            >
                                Đăng nhập bằng
                                {" "}<b>chính tài khoản cuahangykhoa.com</b>
                                {" "}mà bạn đã dùng để mua hoặc nhận sách.
                            </Step>


                            <Step
                                number="7"
                                icon={<BookOutlined />}
                                title='Mở "Sách của tôi"'
                            >
                                Sau khi đăng nhập, mở mục
                                {" "}<b>Sách của tôi</b>.
                                Những sách và tài liệu mà tài khoản đã sở hữu
                                sẽ được đồng bộ trong ứng dụng.
                            </Step>

                        </div>


                        {/* ACCOUNT NOTICE */}
                        <div className="
                            mt-7
                            rounded-2xl
                            border border-green-200
                            bg-green-50
                            p-5
                        ">

                            <div className="flex items-start gap-3">

                                <CheckCircleOutlined className="
                                    mt-1
                                    flex-none
                                    text-[22px]
                                    text-green-600
                                " />

                                <div>

                                    <div className="
                                        font-bold
                                        text-green-900
                                    ">
                                        Không cần mua lại sách
                                    </div>

                                    <div className="
                                        mt-1
                                        text-[14px]
                                        leading-6
                                        text-green-800
                                    ">
                                        Chỉ cần đăng nhập đúng tài khoản
                                        đang sử dụng trên cuahangykhoa.com.
                                        Các nội dung bạn đã sở hữu vẫn được giữ nguyên.
                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* VERIFY FILE */}
                        <details className="
                            mt-7
                            rounded-xl
                            border border-gray-200
                            bg-gray-50
                            p-4
                        ">

                            <summary className="
                                cursor-pointer
                                text-[14px]
                                font-bold
                                text-gray-700
                            ">
                                Thông tin xác minh file tải về
                            </summary>

                            <div className="
                                mt-3
                                text-[12px]
                                leading-5
                                text-gray-600
                            ">

                                <div>
                                    Tên file:
                                    {" "}
                                    <b>OS-BOOKS-Setup.exe</b>
                                </div>

                                <div>
                                    Dung lượng:
                                    {" "}
                                    <b>{FILE_SIZE}</b>
                                </div>

                                <div className="
                                    mt-2
                                    break-all
                                    rounded-lg
                                    bg-white
                                    p-3
                                    font-mono
                                    text-[11px]
                                ">
                                    SHA-256:
                                    <br />
                                    {FILE_SHA256}
                                </div>

                            </div>

                        </details>


                        {/* SUPPORT */}
                        <div className="
                            mt-7
                            text-[13px]
                            leading-5
                            text-gray-500
                        ">
                            Nếu quá trình cài đặt gặp lỗi,
                            vui lòng liên hệ bộ phận hỗ trợ của
                            Cửa Hàng Y Khoa và gửi ảnh màn hình lỗi
                            để được hướng dẫn.
                        </div>

                    </div>

                </div>


                <div className="
                    mt-5
                    flex items-center
                    justify-center
                    gap-2
                    text-center
                    text-[13px]
                    text-gray-500
                ">
                    <LaptopOutlined />

                    OS BOOKS • cuahangykhoa.com
                </div>

            </div>

        </div>
    );
}


function Step({
    number,
    icon,
    title,
    children
}) {

    return (
        <div className="
            flex gap-4
            rounded-2xl
            border border-gray-100
            bg-white
            p-4
            shadow-sm
            md:p-5
        ">

            <div className="
                flex h-10 w-10
                flex-none
                items-center
                justify-center
                rounded-full
                bg-blue-600
                text-[15px]
                font-bold
                text-white
            ">
                {number}
            </div>


            <div className="min-w-0 flex-1">

                <div className="
                    flex items-center gap-2
                    text-[15px]
                    font-bold
                    text-gray-900
                    md:text-[16px]
                ">
                    <span className="text-blue-600">
                        {icon}
                    </span>

                    {title}
                </div>


                <div className="
                    mt-1
                    text-[14px]
                    leading-6
                    text-gray-600
                ">
                    {children}
                </div>

            </div>

        </div>
    );
}
